export const getDefaultRequiredReportParameters = () => ({
  isReportTypeRequired: false,
  isOrganizationIdRequired: false,
  isDistrictIdRequired: false,
  isDistrictIdsRequired: false,
  isSchoolIdRequired: false,
  isSchoolIdsRequired: false,
  isClusterIdRequired: false,
  isTeacherUserIdsRequired: false,
  isSchoolYearRequired: false,
  isStartDateRequired: false,
  isEndDateRequired: false,
  isSummarizeAtLevelRequired: false,
  isIncludeInactiveUsersRequired: false,
  isIncludeNietAdministratorsRequired: false,
  isIncludeDirectorsRequired: false,
  isDataCollectionPeriodRequired: false,
  isGroupByRequired: false,
  isGradeLevelRequired: false,
});

export const getDefaultMissingRequiredReportParameters = () => ({
  isReportTypeMissing: false,
  isOrganizationIdMissing: false,
  isDistrictIdMissing: false,
  isDistrictIdsMissing: false,
  isSchoolIdMissing: false,
  isSchoolIdsMissing: false,
  isClusterIdMissing: false,
  isTeacherUserIdsMissing: false,
  isSchoolYearMissing: false,
  isStartDateMissing: false,
  isEndDateMissing: false,
  isSummarizeAtLevelMissing: false,
  isIncludeInactiveUsersMissing: false,
  isIncludeNietAdministratorsMissing: false,
  isIncludeDirectorsMissing: false,
  isDataCollectionPeriodMissing: false,
  isGroupByMissing: false,
  isGradeLevelMissing: false,
});

export const getMissingRequiredReportParameters = (
  reportParameters,
  requiredReportParameters,
  missingRequiredReportParameters
) => {

  if (
    reportParameters.reportType === undefined &&
    requiredReportParameters.isReportTypeRequired
  ) {
    missingRequiredReportParameters.isReportTypeMissing = true;
  }
  if (
    !reportParameters.organizationId &&
    requiredReportParameters.isOrganizationIdRequired
  ) {
    missingRequiredReportParameters.isOrganizationIdMissing = true;
  }
  if (
    !reportParameters.districtId &&
    requiredReportParameters.isDistrictIdRequired
  ) {
    missingRequiredReportParameters.isDistrictIdMissing = true;
  }
  if (
    !reportParameters.districtIds &&
    requiredReportParameters.isDistrictIdsRequired
  ) {
    missingRequiredReportParameters.isDistrictIdsMissing = true;
  }
  if (
    !reportParameters.schoolId &&
    requiredReportParameters.isSchoolIdRequired
  ) {
    missingRequiredReportParameters.isSchoolIdMissing = true;
  }
  if (
    !reportParameters.clusterId &&
    requiredReportParameters.isClusterIdRequired
  ) {
    missingRequiredReportParameters.isClusterIdMissing = true;
  }
  if (
    !reportParameters.schoolIds &&
    requiredReportParameters.isSchoolIdsRequired
  ) {
    missingRequiredReportParameters.isSchoolIdsMissing = true;
  }
  if (
    !reportParameters.teacherUserIds &&
    requiredReportParameters.isTeacherUserIdsRequired
  ) {
    missingRequiredReportParameters.isTeacherUserIdsMissing = true;
  }
  if (
    !reportParameters.schoolYear &&
    requiredReportParameters.isSchoolYearRequired
  ) {
    missingRequiredReportParameters.isSchoolYearMissing = true;
  }
  if (
    !reportParameters.startDate &&
    requiredReportParameters.isStartDateRequired
  ) {
    missingRequiredReportParameters.isStartDateMissing = true;
  }
  if (!reportParameters.endDate && requiredReportParameters.isEndDateRequired) {
    missingRequiredReportParameters.isEndDateMissing = true;
  }
  if (
    (reportParameters.isSummarizeAtLevel === null ||
      reportParameters.isSummarizeAtLevel === undefined) &&
    requiredReportParameters.isSummarizeAtLevelRequired
  ) {
    missingRequiredReportParameters.isSummarizeAtLevelMissing = true;
  }
  if (
    (reportParameters.includeInactiveUsers === null ||
      reportParameters.includeInactiveUsers === undefined) &&
    requiredReportParameters.isIncludeInactiveUsersRequired
  ) {
    missingRequiredReportParameters.isIncludeInactiveUsersMissing = true;
  }
  if (
    (reportParameters.includeNietAdministrators === null ||
      reportParameters.includeNietAdministrators === undefined) &&
    requiredReportParameters.isIncludeNietAdministratorsRequired
  ) {
    missingRequiredReportParameters.isIncludeNietAdministratorsMissing = true;
  }
  if (
    (reportParameters.includeDirectors === null ||
      reportParameters.includeDirectors === undefined) &&
    requiredReportParameters.isIncludeDirectorsRequired
  ) {
    missingRequiredReportParameters.isIncludeDirectorsMissing = true;
  }
  if (
    !reportParameters.dataCollectionPeriod &&
    requiredReportParameters.isDataCollectionPeriodRequired
  ) {
    missingRequiredReportParameters.isDataCollectionPeriodMissing = true;
  }
  if (
    !reportParameters.groupBy &&
    requiredReportParameters.isGroupByRequired
  ) {
    missingRequiredReportParameters.isGroupByMissing = true;
  }
  if (
    !reportParameters.gradeLevel &&
    requiredReportParameters.isGradeLevelRequired
  ) {
    missingRequiredReportParameters.isGradeLevelMissing = true;
  }
  return missingRequiredReportParameters;
};

// Human-readable labels for each missing-parameter flag, keyed the same way
// as getDefaultMissingRequiredReportParameters(). Used to announce which
// report filters still need a value instead of only silently disabling the
// Run Report button.
const MISSING_REPORT_PARAMETER_LABELS = {
  isReportTypeMissing: "Report Type",
  isOrganizationIdMissing: "Organization",
  isDistrictIdMissing: "District",
  isDistrictIdsMissing: "District",
  isSchoolIdMissing: "School",
  isSchoolIdsMissing: "School",
  isClusterIdMissing: "Cluster",
  isTeacherUserIdsMissing: "Teachers",
  isSchoolYearMissing: "School Year",
  isStartDateMissing: "Start Date",
  isEndDateMissing: "End Date",
  isSummarizeAtLevelMissing: "Summarize at Level",
  isIncludeInactiveUsersMissing: "Include Inactive Users",
  isIncludeNietAdministratorsMissing: "Include NIET Administrators",
  isIncludeDirectorsMissing: "Include Directors",
  isDataCollectionPeriodMissing: "Data Collection Period",
  isGroupByMissing: "Group By",
  isGradeLevelMissing: "Grade Level",
};

export const getMissingRequiredReportParameterLabels = (
  missingRequiredReportParameters
) =>
  [
    ...new Set(
      Object.keys(missingRequiredReportParameters)
        .filter((key) => missingRequiredReportParameters[key] === true)
        .map((key) => MISSING_REPORT_PARAMETER_LABELS[key])
        .filter(Boolean)
    ),
  ];
